import type { Theme } from '@mui/material';
import type { MarkdownStylesParams } from './markdown.types';

const MARKDOWN_LINE_HEIGHT = 1.65;

export const getMarkdownStyles =
  ({ variant, colorToken }: MarkdownStylesParams) =>
  (theme: Theme) => ({
    ...theme.typography[variant],
    lineHeight: MARKDOWN_LINE_HEIGHT,
    color: colorToken,
    maxWidth: '100%',
    minWidth: 0,
    '& p': { margin: theme.spacing(0, 0, 1.25), lineHeight: MARKDOWN_LINE_HEIGHT },
    '& p:last-child': { marginBottom: 0 },
    '& ul, & ol': { margin: theme.spacing(0, 0, 1.25), paddingLeft: theme.spacing(2.5) },
    '& li': { margin: theme.spacing(0.75, 0), lineHeight: MARKDOWN_LINE_HEIGHT },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      margin: theme.spacing(1.5, 0, 0.75),
      fontWeight: theme.typography.fontWeightMedium,
    },
    '& h1': { fontSize: theme.typography.h1.fontSize },
    '& h2': { fontSize: theme.typography.h2.fontSize },
    '& h3': { fontSize: theme.typography.h3.fontSize },
    '& h4': { fontSize: theme.typography.h4.fontSize },
    '& h5': { fontSize: theme.typography.h5.fontSize },
    '& h6': { fontSize: theme.typography.h6.fontSize },
    '& a, & [data-streamdown="link"]': {
      appearance: 'none',
      border: 'none',
      background: 'none',
      padding: 0,
      fontFamily: 'inherit',
      fontSize: 'inherit',
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      textUnderlineOffset: '2px',
      cursor: 'pointer',
      overflowWrap: 'anywhere',
    },
    '& strong, & b, & [data-streamdown="strong"]': {
      fontWeight: theme.typography.fontWeightBold,
    },
    '& img': { maxWidth: '100%', height: 'auto', borderRadius: 1 },
    '& blockquote': {
      margin: theme.spacing(0, 0, 1),
      paddingLeft: theme.spacing(1.5),
      borderLeft: `3px solid ${theme.palette.divider}`,
      color: theme.palette.text.secondary,
    },
    '& hr': {
      border: 'none',
      borderTop: `1px solid ${theme.palette.divider}`,
      margin: theme.spacing(1.5, 0),
    },
  });
